<template>
  <ODialog ref="dialog" :maxWidth="600" hideWhenLoading>
    <v-card v-if="allVehicles != null">
      <ODialogBar title="Copiar Configurações" @close="dismiss" />

      <template v-if="currentTab == 1">
        <v-card-text class="px-4 py-6">
          <v-text-field
            autofocus
            filled
            class="elevation-0"
            v-model="txtFilter"
            placeholder="Buscar por placa/código auxiliar..."
            single-line
            hide-details
            append-inner-icon="mdi-magnify"
          />
        </v-card-text>

        <v-card-text class="pa-0 maxh-4">
          <v-list class="py-0 px-0">
            <!-- clipboard, se existir -->
            <v-list-item
              v-if="fromClipboard != null"
              class="px-7 yellow lighten-1"
              @click="selectFromClipboard"
            >
              <v-list-item-content>
                <v-list-item-title>
                  Clipboard: configs do veículo {{ fromClipboard.origin }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>

            <!-- veículos filtrados -->
            <v-list-item
              v-for="row in vehiclesSlice"
              :key="row.id"
              class="px-7"
              @click="selectVehicle(row)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <OSpans :pieces="[row.code, row.extraCode]" />
                </v-list-item-title>
                <v-list-item-subtitle style="line-height: 22px">
                  <OSpans
                    style="opacity: 0.7"
                    eachClass="tag mr-1"
                    :pieces="row.chips"
                  />
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-btn
            block
            text
            v-if="filteredVehicles.length >= max"
            @click="max += 20"
          >
            <v-icon x-small>mdi-arrow-down</v-icon>
            Mais...
            <v-icon x-small>mdi-arrow-down</v-icon>
          </v-btn>
        </v-card-text>
      </template>

      <template v-if="currentTab == 2">
        <v-card-text class="px-4 py-6">
          Selecione as configurações que serão copiadas.
        </v-card-text>
        <v-card-text class="pa-0">
          <v-list class="py-0 px-0">
            <v-list-item @click="toggleAll">
              <v-list-item-action>
                <OCheckIcon :value="allSelected" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>(Todas)</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <div class="maxh-4">
              <v-list-item
                v-for="g in copyItems"
                :key="g.text"
                :class="g.isSelected && 'oderon lighten-1'"
                @click="g.isSelected = !g.isSelected"
              >
                <v-list-item-action>
                  <OCheckIcon :value="g.isSelected" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-space-between">
                    <span>{{ g.text }}</span>
                    <span>{{ g.strValue }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list>
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          txtApply="Copiar selecionadas"
          @apply="apply"
          @cancel="currentTab = 1"
        />
      </template>
    </v-card>
  </ODialog>
</template>

<script>
import { Vehicle } from '@/models'
import utils from 'oderon-commons/src/utils'

import * as rpm from './RPMConfigItem.vue'
import * as speed from './SpeedConfigItem.vue'
import * as odo from './OdoConfigItem.vue'
import * as horo from './HoroConfigItem.vue'
import * as brake from './BrakeConfigItem.vue'
import * as dg from './DGConfigItem.vue'
import * as an from './ANConfigItem.vue'
import * as generic from './GenericConfigItem.vue'
import * as canDict from './CANDictConfigItem.vue'
import configGroups from './ConfigGroups.js'

function makeCopyItems(allConfigs) {
  let result = []

  result.push({
    isSelected: false,
    text: 'Dicionário CAN',
    value: canDict.copyValue(allConfigs),
    strValue: canDict.displayValue(allConfigs)
  })

  result.push({
    isSelected: false,
    text: 'RPM',
    value: rpm.copyValue(allConfigs),
    strValue: rpm.displayValue(allConfigs)
  })

  result.push({
    isSelected: false,
    text: 'Velocidade',
    value: speed.copyValue(allConfigs),
    strValue: speed.displayValue(allConfigs)
  })

  result.push({
    isSelected: false,
    text: 'Odômetro',
    value: odo.copyValue(allConfigs),
    strValue: odo.displayValue(allConfigs)
  })

  result.push({
    isSelected: false,
    text: 'Horímetro',
    value: horo.copyValue(allConfigs),
    strValue: horo.displayValue(allConfigs)
  })

  result.push({
    isSelected: false,
    text: 'Freio',
    value: brake.copyValue(allConfigs),
    strValue: brake.displayValue(allConfigs)
  })

  for (let i = 1; i <= 4; i++) {
    result.push({
      isSelected: false,
      text: 'AN' + i,
      value: an.copyValue(allConfigs, i),
      strValue: an.displayValue(allConfigs, i)
    })
  }

  for (let i = 1; i <= 3; i++) {
    result.push({
      isSelected: false,
      text: 'DG' + i,
      value: dg.copyValue(allConfigs, i),
      strValue: dg.displayValue(allConfigs, i)
    })
  }

  // misc, gps, jornada, audio
  let otherGroups = configGroups.filter((x) => {
    return (
      x.groupName != 'Sinais Analógicos' && x.groupName != 'Sinais Digitais'
    )
  })

  for (let group of otherGroups) {
    for (let configDef of group.configs) {
      result.push({
        isSelected: false,
        text: group.groupName + '/' + configDef.label,
        value: generic.copyValue(allConfigs, configDef),
        strValue: generic.displayValue(allConfigs, configDef)
      })
    }
  }

  return result
}

export default {
  data() {
    return this.reset()
  },
  computed: {
    filteredVehicles() {
      return this.allVehicles.filter((x) =>
        utils.matchAnyLike(
          this.txtFilter,
          x.code,
          x.extraCode,
          x.brandModel && x.brandModel.name
        )
      )
    },
    vehiclesSlice() {
      return this.filteredVehicles.slice(0, this.max)
    },
    allSelected() {
      return this.copyItems.every((x) => x.isSelected)
    }
  },
  methods: {
    reset() {
      return {
        max: 20,
        txtFilter: null,
        allVehicles: [],
        currentTab: 1,
        fromClipboard: null,
        copyItems: []
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    open() {
      Object.assign(this, this.reset())
      this.$refs.dialog.$loading(() => this.fetchData())
      this.tryClipboard()
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      let rows = await Vehicle.findMini()
      rows.forEach((r) => {
        r.chips = []
        r.chips.push({ text: r.org.name })

        let tags = r.tags || []

        let group = tags.find((x) => x.toLowerCase().startsWith('grupo:'))
        if (group) r.chips.push({ text: group, cssClass: 'blue' })

        if (r.brandModel) r.chips.push({ text: r.brandModel.name })

        let desmob = tags.find((x) => x.toLowerCase() == 'desmobilizado')
        if (desmob) r.chips.push({ text: desmob, cssClass: 'red' })
      })
      this.allVehicles = rows
    },

    async selectVehicle(vehicle) {
      this.$rootLoading(async () => {
        let rows = await Vehicle.getConfigs(vehicle.id)
        this.copyItems = makeCopyItems(rows)
        this.currentTab = 2
      })
    },

    async selectFromClipboard() {
      this.copyItems = makeCopyItems(this.fromClipboard.configs)
      this.currentTab = 2
    },

    async tryClipboard() {
      this.fromClipboard = null
      try {
        let str = await navigator.clipboard.readText()
        let data = JSON.parse(str)
        if (data.type == 'vehicleConfigs') this.fromClipboard = data
      } catch (err) {
        // noop
      }
    },

    apply() {
      // Mergeia todas as configs selecionadas em um único payload.
      let payload = {}
      for (let item of this.copyItems) {
        if (item.isSelected) {
          Object.assign(payload, item.value)
        }
      }
      this.$refs.dialog.$apply(payload)
    },

    toggleAll() {
      if (this.allSelected) {
        this.copyItems.forEach((x) => (x.isSelected = false))
      } else {
        this.copyItems.forEach((x) => (x.isSelected = true))
      }
    }
  }
}
</script>

<style></style>
